import React from 'react';
import MWSVG from './svg';

type Props = {
    text: any;
    className?: string;
};

const KEYBlue: React.FC<Props> = ({ text, className }) => {
    return (
        <div className={`flex items-start mb-0 fw-500 fs-md text-textcolor dark:text-light ${className}`}>
            <MWSVG id="tabler-icon-square-rounded-check-filled" svgClassName="me-2.5 mt-[2px] min-w-[24px]" />
            {text}
        </div>
    );
};

export default KEYBlue;
